import { render, staticRenderFns } from "./harvests.vue?vue&type=template&id=c5c70f4e&"
import script from "./harvests.vue?vue&type=script&lang=js&"
export * from "./harvests.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports